import {ChangeDetectionStrategy, Component, HostBinding, input} from '@angular/core';

@Component({
  selector: 'homey-next-home-card',
  imports: [],
  templateUrl: './next-home-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NextHomeCardComponent {
  @HostBinding('class') readonly class = 'flex flex-row items-center rounded-lg bg-surface-100 p-4';
  public readonly title = input.required<string>();
  public readonly description = input.required<string>();
}
